import { React, classNames } from '@digsup/core-ui'; // eslint-disable-line no-unused-vars
import { Button } from '@digsup/components-button';
import Error404Image from './images/404.svg';
import { styles } from './Error404.scss';

const cx = classNames.bind(styles);

export const Error404 = () => {
  const classes = cx('c-error-404');

  return (
    <div className={classes}>
      <div className="c-error-404__wrapper">
        <img className="c-error-404__image" src={Error404Image} alt="404" />
        <h1 className="c-error-404__title">Look into my Crystal Ball...</h1>
        <p className="c-error-404__text">
          You are searching for something. Something with an address... But not
          this one; this one is no good for you. Only errors! Now what&apos;s
          this I see?
          <br />
          <span>A beautiful home! I see you opening the front door...</span>
        </p>
        <Button variant="primary" width="default" className="u-display-block">
          Gaze Deeper
        </Button>
      </div>
    </div>
  );
};
